import { render, staticRenderFns } from "./BackLinkComponent.vue?vue&type=template&id=175cee96&scoped=true"
import script from "./BackLinkComponent.vue?vue&type=script&lang=js"
export * from "./BackLinkComponent.vue?vue&type=script&lang=js"
import style0 from "./BackLinkComponent.vue?vue&type=style&index=0&id=175cee96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175cee96",
  null
  
)

export default component.exports